import { render, staticRenderFns } from "./cabinet-map.vue?vue&type=template&id=2a418fac&scoped=true"
import script from "./cabinet-map.vue?vue&type=script&lang=ts"
export * from "./cabinet-map.vue?vue&type=script&lang=ts"
import style0 from "./cabinet-map.vue?vue&type=style&index=0&id=2a418fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a418fac",
  null
  
)

export default component.exports